/* Copyright 2021, Milkdown by Mirone. */
import { nodeFactory } from '@milkdown/core';
import { commonPlugin } from './base-common';
import { createKeymap } from './keymap';
export const createNode = (factory) => {
    const origin = (options) => {
        const plugin = nodeFactory((ctx) => {
            var _a;
            const node = commonPlugin(factory, ctx, options);
            const view = (_a = options === null || options === void 0 ? void 0 : options.view) !== null && _a !== void 0 ? _a : node.view;
            const keymap = createKeymap(node.shortcuts, options === null || options === void 0 ? void 0 : options.keymap);
            return Object.assign(Object.assign({}, node), { view,
                keymap });
        });
        plugin.origin = origin;
        return plugin;
    };
    return origin;
};
//# sourceMappingURL=base-node.js.map